import {Flex, Text} from '@chakra-ui/react'
import React from 'react'
import {FormattedMessage, FormattedNumber} from 'react-intl'
import {useOrderSummary} from './order-summary-provider'
import {useCurrentCustomer} from '../../hooks/use-current-customer'

const OrderSummaryTax = () => {
    const basket = useOrderSummary()
    const {isCustomNetPriceEnabled} = useCurrentCustomer().data

    return (
        <Flex gap={6} minWidth="100%" justify="space-between">
            <Flex flexDirection="row" gap={2} data-testid="totalprice_text">
                <Text>
                    <FormattedMessage defaultMessage="Total" id="global.total" />
                </Text>
                {isCustomNetPriceEnabled && (
                    <Text color="stokkeGray.accessibleText">
                        <FormattedMessage
                            id="global.taxes_not_included"
                            defaultMessage="tax not included"
                        />
                    </Text>
                )}
            </Flex>

            <Text data-testid="totalprice_value">
                <FormattedNumber
                    value={
                        !isCustomNetPriceEnabled
                            ? basket?.orderTotal || basket?.productTotal
                            : basket.c_totalNetPrice
                    }
                    style="currency"
                    currency={basket.currency}
                />
            </Text>
        </Flex>
    )
}

export default OrderSummaryTax
